import { Observable, catchError, map, of, switchMap, throwError } from 'rxjs';

import { ResultType } from './checklist.model';
import { ListResponse, QueryParams, recursiveQuery } from './utility.model';

export type MeasFile = {
  name: string;
  unitCount: number;
};

export type MeasGroupLogicalFieldMap = {
  name: string;
  dataName: string;
  resultType: ResultType;
};

export type MeasGroup = {
  name: string;
  protocol: string;
  logicalFields: MeasGroupLogicalFieldMap[];
  files: MeasFile[];
};
export type MeasGroupWithRevision = {
  items: MeasGroup[];
  revision: number;
};

export type MeasGroupQueryParams = QueryParams;
export type MeasGroupListResponse<T> = ListResponse<T> & { revision: number };
type MeasGroupQueryFunction<T extends QueryParams, R> = (params: T) => Observable<MeasGroupListResponse<R>>;
type MeasGroupQueryResult<R> = { items: R[]; revision: number };
export function recursiveQueryWithRevision<T extends QueryParams, R>(
  func: MeasGroupQueryFunction<T, R>,
  params: T,
  canCatchError?: boolean,
): Observable<MeasGroupQueryResult<R>> {
  return func(params).pipe(
    switchMap(({ nextToken, items, revision }) => {
      if (!nextToken) {
        return of({ items, revision });
      }
      return recursiveQuery(func, { ...params, nextToken }, canCatchError).pipe(
        map(remainingItems => ({ items: [...items, ...remainingItems], revision: revision })),
      );
    }),
    catchError(err => (canCatchError ? throwError(() => new Error(err)) : of({ items: [] as R[], revision: 0 }))),
  );
}
